var map = {
	"./feature_buy_bonus_cn.png": 95534,
	"./feature_buy_bonus_en.png": 47448,
	"./feature_buy_bonus_id.png": 52630,
	"./feature_buy_bonus_ko.png": 29647,
	"./feature_buy_bonus_ph.png": 97853,
	"./feature_buy_bonus_th.png": 91894,
	"./feature_buy_bonus_zh.png": 54571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90458;